import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function FormCard({ title, description, children }) {
  return (
    <Box
      sx={{
        p: { xs: "12px 14px", sm: "14px 16px" },
        mb: 1.25,
        borderRadius: "10px",
        border: "1px solid #e5e7eb",
        bgcolor: "#f9fafb",
      }}
    >
      <Typography
        component="p"
        sx={{
          fontWeight: 600,
          fontSize: "0.875rem",
          lineHeight: 1.3,
          color: "#111827",
          mb: description ? 0.5 : 0.875,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          component="p"
          sx={{
            fontSize: "0.775rem",
            color: "#6b7280",
            lineHeight: 1.45,
            mb: 0.875,
          }}
        >
          {description}
        </Typography>
      )}
      {children}
    </Box>
  );
}
